module.exports = __webpack_public_path__ + "img/alxq1.dc4b8c70.png";